/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react'
import {ParamsModelProizvodnja} from '../../../../models/ProizvodnjaModel'
import PanelListSection from '../PanelListSection'
import PanelTipDropdown from '../PanelTipDropdown/PanelTipDropdown'
import KomercijalistePanelaDropdown from '../KomercijalistePanelaDropdown/KomercijalistePanelaDropdown'
import KupciPanelaDropdown from '../KupciPanelaDropdown/KupciPanelaDropdown'
import useDebounce from '../../../../hooks/useDebounce'

const ProizodnjaFilteri = ({onFilter}) => {
  const [filters, setfilters] = useState<Partial<ParamsModelProizvodnja>>({})
  const [brojNalog, setBrojNalog] = useState<string>('')

  // Trigger filter on change
  useEffect(() => {
    onFilter(filters)
  }, [filters])

  const debouncedBrojNalog = useDebounce(brojNalog)

  useEffect(() => {
    const re = new RegExp('^\\s*\\d{6}/\\d{2}\\s*$')

    if (re.test(debouncedBrojNalog)) {
      setfilters((prev) => ({
        ...prev,
        brojNalog: debouncedBrojNalog.trim(),
      }))
    } else {
      setfilters((prev) => {
        const newFilters = {...prev}
        delete newFilters.brojNalog
        return newFilters
      })
    }
  }, [debouncedBrojNalog])

  const activeCount = Object.values(filters).filter(
    (value) => value !== undefined && value !== null && value !== ''
  ).length

  return (
    <PanelListSection
      title='Filteri'
      description='Suzite pregled naloga. Filteri se primjenjuju automatski.'
      icon='bi-funnel'
      initiallyOpen
      badge={<span className='badge badge-light-primary'>Aktivni: {activeCount}</span>}
    >
      <div className='row g-5'>
        <div className='col-12 col-md-6 col-xl-4'>
          <label htmlFor='panel-filter-status' className='form-label fw-semibold'>
            Status proizvodnje
          </label>
          <select
            id='panel-filter-status'
            className='form-select form-select-solid'
            onChange={(e) =>
              setfilters((prev) => ({...prev, statusPro: e.target.value || undefined}))
            }
          >
            <option value=''>Svi statusi</option>
            <option value='Zavrseno'>Završeno</option>
            <option value='Planirano'>Planirano</option>
            <option value='U proizvodnji'>U proizvodnji</option>
            <option value='Na čekanju'>Na čekanju</option>
          </select>
        </div>
        <div className='col-12 col-md-6 col-xl-4'>
          <div className='form-label fw-semibold'>Tip panela</div>
          <PanelTipDropdown
            onChange={(name, value) => setfilters((prev) => ({...prev, tipPanela: value}))}
          />
        </div>
        <div className='col-12 col-md-6 col-xl-4'>
          <div className='form-label fw-semibold'>Komercijalista</div>
          <KomercijalistePanelaDropdown
            onChange={(name, value) => setfilters((prev) => ({...prev, kreiraoKorisnik: value}))}
          />
        </div>
        <div className='col-12 col-md-6 col-xl-4'>
          <div className='form-label fw-semibold'>Kupac</div>
          <KupciPanelaDropdown
            onChange={(name, value) => setfilters((prev) => ({...prev, idKupac: value}))}
          />
        </div>
        <div className='col-12 col-md-6 col-xl-4'>
          <label htmlFor='panel-filter-nalog' className='form-label fw-semibold'>
            Broj naloga
          </label>
          <input
            id='panel-filter-nalog'
            type='text'
            className='form-control form-control-solid'
            placeholder='Npr. 123456/25'
            value={brojNalog}
            aria-describedby='panel-filter-nalog-help'
            onChange={(e) => setBrojNalog(e.target.value)}
          />
          <div id='panel-filter-nalog-help' className='text-muted fs-8 mt-2'>
            Unesite šest cifara, kosu crtu i godinu.
          </div>
        </div>
        <div className='col-12 col-md-6 col-xl-4'>
          <label htmlFor='panel-filter-days' className='form-label fw-semibold'>
            Starost završenih naloga
          </label>
          <select
            id='panel-filter-days'
            className='form-select form-select-solid'
            onChange={(e) =>
              setfilters((prev) => ({...prev, daysRange: e.target.value || undefined}))
            }
          >
            <option value=''>Svi periodi</option>
            <option value='1-15'>1 - 15 dana</option>
            <option value='15-30'>15 - 30 dana</option>
            <option value='30-45'>30 - 45 dana</option>
            <option value='45-60'>45 - 60 dana</option>
            <option value='60+'>60+ dana</option>
          </select>
        </div>
      </div>
    </PanelListSection>
  )
}

export default ProizodnjaFilteri
